export function usePaginationAdmin(
  page: number,
  setPage: (value: number) => void,
  refetchOrPageCount: (() => void) | number,
  maybePageCount?: number
) {
  const hasRefetch = typeof refetchOrPageCount === 'function';
  const refetch = hasRefetch ? (refetchOrPageCount as () => void) : undefined;
  const pageCount = hasRefetch
    ? maybePageCount ?? 1
    : (refetchOrPageCount as number);

  const updatePage = (value: number) => {
    setPage(value);
    refetch?.();
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const nextPage = () => {
    if (page < pageCount) {
      updatePage(page + 1);
    }
    setTimeout(scrollToTop, 200);
  };

  const previousPage = () => {
    if (page >= 1) {
      updatePage(page - 1);
    }
    setTimeout(scrollToTop, 200);
  };

  const lastPage = () => {
    updatePage(pageCount);

    setTimeout(scrollToTop, 200);
  };

  const firstPage = () => {
    updatePage(1);

    setTimeout(scrollToTop, 200);
  };

  return { nextPage, previousPage, lastPage, firstPage };
}
